const en = {
  common: {
    admin: 'ADMIN',
    sysadmin: 'sysadmin',
    eventadmin: 'eventadmin',
    noRole: 'no access',
    anonymous: 'Anonymous',
    logout: 'Logout',
    back: 'Back',
    cancel: 'Cancel',
    save: 'Save changes',
    edit: 'Edit',
    delete: 'Delete',
    remove: 'Remove',
    add: 'Add',
    create: 'Create',
    close: 'Close',
    saving: 'Saving...',
    creating: 'Creating...',
    uploading: 'Uploading...',
    adding: 'Adding...',
    loading: 'Loading...',
    download: 'Download',
    copyLink: 'Copy Link',
    next: 'Next',
    prev: 'Prev',
    loadMore: 'Load More',
    noPermission: 'You do not have permission to view this page.',
    anonymousNotice: 'You are logged in as anonymous. Please log out and use a valid admin account.',
    urlCopied: 'URL copied to clipboard',
    linkCopied: 'Link copied to clipboard',
    downloadFailed: 'Download failed',
    preparingDownload: 'Preparing download...',
    share: 'Share',
    shareFailed: 'Sharing failed',
    preparingShare: 'Preparing video...',
  },
  nav: {
    events: 'Events',
    users: 'Users',
    eventTypes: 'Event Types',
    templates: 'Templates',
  },
  login: {
    title: 'Admin Dashboard',
    subtitle: 'Sign in to manage events, users, and moderation.',
    email: 'Email',
    emailPlaceholder: 'you@example.com',
    password: 'Password',
    passwordPlaceholder: '••••••••',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    signIn: 'Sign in',
    forgotPassword: 'Forgot your password?',
    emailRequired: 'Email is required',
    emailInvalid: 'Enter a valid email address',
    passwordRequired: 'Password is required',
    loginFailed: 'Login failed',
    enterEmailFirst: 'Enter your email first',
    enterEmailFirstDesc: 'Type your email address above, then click this link.',
    resetEmailSent: 'Reset email sent',
    resetEmailSentDesc: 'Check {email} for a password reset link.',
    resetEmailFailed: 'Could not send reset email',
    resetTooMany: 'Too many requests for this address. Wait a few minutes and try again.',
  },
  events: {
    title: 'Events',
    streamingAndGallery: 'Streaming & gallery',
    enableStreaming: 'Cloudflare streaming & public gallery',
    streamingSysadminOnly: 'Only a sysadmin can change this',
    galleryPublic: 'Gallery is publicly visible',
    galleryPublicHint: 'When off, only registered accounts can see this event\'s videos. Reels are always public.',
    galleryUrl: 'Gallery link',
    galleryQrTitle: 'Gallery QR Code',
    backfillPending: 'Some videos have not been sent to Cloudflare yet.',
    sendRemaining: 'Send remaining',
    sendRemainingDone: 'Sent {count}, {remaining} still pending',
    backfillAuthors: 'Refresh creator names',
    backfillAuthorsHint: 'Adds the creator name to gallery items published before names were recorded, recovering it from the sign-in record where needed. Nothing is re-encoded.',
    backfillAuthorsDone: 'Updated {updated} of {scanned} gallery items, {recovered} names recovered',
    subtitle: 'List, sort, and jump into control or moderation.',
    sortByPlaceholder: 'Sort by',
    sortByName: 'Sort by name',
    sortByCreated: 'Sort by creation date',
    filterAllTypes: 'All types',
    createEvent: 'Create event',
    closeCreator: 'Close creator',
    whatKind: 'What kind of event?',
    normalEvent: 'Normal event',
    wedding: 'Wedding',
    failedToLoad: 'Failed to load events',
    untitled: 'Untitled event',
    moderation: 'Moderation',
    videos: 'Videos',
    reels: 'Reels',
    prizes: 'Prizes',
    eventName: 'Event name',
    eventNamePlaceholder: 'Click to set event name',
    eventNameEditPlaceholder: 'Event name',
    eventDeleted: 'Event deleted',
    eventDeleteFailed: 'Failed to delete event',
    eventUpdated: 'Event updated',
    eventUpdateFailed: 'Failed to update event',
    allEventsLink: '← All events',
    deleteEventTitle: 'Delete Event',
    deleteEventConfirm: 'Are you sure you want to delete {name}? Everything that belongs to it will be permanently deleted: videos and reels (including their Cloudflare copies and share links), prizes, analytics, team roles, settings and uploaded images. This action cannot be undone.',
    deleteEventAria: 'Delete event',
    images: 'Images',
    themeColors: 'Theme Colors',
    challengeBackground: 'Challenge Background',
    logo: 'Logo',
    prizeBackground: 'Prize Background',
    splashScreen: 'Splash Screen',
    backgroundColor: 'Background',
    surfaceColor: 'Surface',
    primaryColor: 'Primary',
    textColor: 'Text',
    challengePrompt: 'Challenge instructions',
    challengePromptPlaceholder: 'e.g. Pick a challenge and record a video!',
    promptColor: 'Prompt Color',
    maxVideosPerUser: 'Max videos per user',
    maxVideosPlaceholder: 'No limit',
    maxVideosHelp: 'Leave empty for unlimited. Only applies when Prize Mode is off.',
    prizeMode: 'Prize Mode',
    enablePrizeMode: 'Enable Prize Mode',
    enablePrizeModeHelp: 'Users must complete all challenges to win a prize.',
    requireLogin: 'Require user login',
    requireLoginHelp: 'When off, anonymous users can participate but risk losing progress.',
    maxRejections: 'Max rejections per challenge',
    prizeConfig: 'Prize Configuration',
    prizeTitle: 'Prize title',
    prizeTitlePlaceholder: 'Congratulations!',
    prizeDescription: 'Prize description',
    prizeDescriptionPlaceholder: 'Show this QR code to claim your prize at the booth',
    prizePrompt: 'Prize prompt',
    prizePromptPlaceholder: 'Show this QR to staff to claim your prize!',
    validatorCodes: 'Validator Access Codes',
    validatorCodesHelp: 'Share these codes with event staff who will validate prize QR codes.',
    generateValidatorCode: 'Generate new code',
    copyValidatorUrl: 'Copy validator URL',
    videoCountOne: '{count} video',
    videoCountMany: '{count} videos',
    reelCountOne: '{count} reel',
    reelCountMany: '{count} reels',
    showQrCode: 'Show QR code',
    removeCode: 'Remove code',
    validatorQrTitle: 'Validator QR Code',
    recordingSettings: 'Recording Settings',
    maxSegmentDuration: 'Max segment duration (seconds)',
    maxSegmentDurationHelp: 'Maximum length of the trimmed clip users can submit.',
    maxRecordingDuration: 'Max recording duration (seconds)',
    maxRecordingDurationHelp: 'Maximum time the camera will record before auto-stopping.',
    videoReception: 'Video Reception',
    acceptSubmissions: 'Accept video submissions',
    acceptSubmissionsHelp: 'When disabled, the webapp will not allow new video uploads.',
    receptionStart: 'Reception start',
    receptionEnd: 'Reception end',
    moderationSettings: 'Moderation Settings',
    autoApprove: 'Auto-approve new videos',
    autoApproveHelp: 'When enabled, uploaded videos skip the moderation queue.',
    infoSection: 'Info & Terms (webapp)',
    infoSectionHelp: 'Markdown content shown in the webapp Info menu. Supports headings, lists, bold, italic, links.',
    infoPlaceholder: 'Write the info / terms content in Markdown...',
    infoResetDefault: 'Reset to default',
  },
  qr: {
    title: 'QR Code',
    placeholder: 'Qr code will be generated when event is created',
    copyEventUrl: 'Copy event URL',
    downloadQr: 'Download QR',
  },
  eventBackground: {
    noImage: 'This event does not have a {name} image.',
    dropReplace: 'Drop to replace {name}',
    dropImage: 'Drop {name} image here or click to upload',
    removeImage: 'Remove {name} Image',
    colorSuffix: '{name} Color',
  },
  eventUsers: {
    title: 'Event admin users',
    notCreatedYet: 'You will be able to add users once the event is created.',
    loadingUser: 'Loading user...',
    loadingError: 'Error loading user: {message}',
    loadingAdmins: 'Loading event admin users...',
    loadingAdminsError: 'Error loading event admin users: {message}',
    addAdminUser: 'Add admin user',
    userEmail: 'User email',
    role: 'Role',
    eventAdmin: 'Event admin',
    moderator: 'Moderator',
    weddingOrganizer: 'Wedding organizer',
    typeOrganizer: '{{type}} organizer',
    adding: 'Adding...',
    removeTitle: 'Remove user',
    removeConfirm: 'Remove {user} from this event? They will lose access to it.',
    removing: 'Removing...',
    removed: 'User removed from event',
    removeFailed: 'Failed to remove user: {message}',
  },
  challenges: {
    title: 'Challenges',
    name: 'Challenge name',
    background: 'Background',
    text: 'Text',
    selfieCamera: 'Selfie camera',
    deleteAria: 'Delete event',
    addChallenge: 'Add new challenge',
  },
  wedding: {
    createTitle: 'Create wedding event',
    createButton: 'Create wedding event',
    couple: 'Couple',
    couplePlaceholder: 'e.g. Alex & Sam',
    coupleHelp: 'Used as the event name.',
    receptionStart: 'Reception start',
    receptionEnd: 'Reception end',
    adminEmail: 'Wedding admin email',
    adminEmailPlaceholder: 'organizer@example.com',
    adminEmailHelp: 'Invited as the wedding organizer for this event.',
    coupleRequired: 'Couple name is required',
    startRequired: 'Start date and time is required',
    endRequired: 'End date and time is required',
    endAfterStart: 'End must be after start',
    adminEmailRequired: 'Wedding admin email is required',
    emailInvalid: 'Enter a valid email',
    created: 'Wedding event created',
    inviteFailed: 'Event created — admin invite failed',
    inviteFailedDesc: '{message}. Invite the organizer from the event settings.',
    createFailed: 'Failed to create wedding event',
    unknownError: 'Unknown error',
  },
  moderation: {
    loading: 'Loading moderation...',
    noAccess: 'No access to this event',
    grid: 'Grid',
    inQueue: '{count} in queue',
    nextVideos: 'Next videos',
    filterPending: 'Pending',
    filterAll: 'All',
    filterAccepted: 'Accepted',
    filterRejected: 'Rejected',
    loadingVideos: 'Loading videos…',
    noVideosFilter: 'No videos for this filter.',
    keyboardHints: '←↑↓→ navigate · A accept · X reject · F favourite · Space start/pause',
    rejectAll: 'Reject all',
    acceptAll: 'Accept all',
    failedToLoad: 'Failed to load videos',
    bulkSuccess: 'Bulk {action} {count} videos',
    bulkActionAccepted: 'accepted',
    bulkActionRejected: 'rejected',
    bulkFailed: 'Bulk moderation failed',
    statusAccepted: 'Accepted',
    statusRejected: 'Rejected',
    statusInModeration: 'In Moderation',
    statusPending: 'Pending',
    start: 'MODERATE',
    pause: 'PAUSE',
    pausedTitle: 'MODERATION PAUSED',
    you: 'you',
    holdingCount: 'holding {count}',
    takenOver: 'Taken by another moderator',
    decidedElsewhere: 'Decided by another moderator',
    waitingBanner: '{count} videos are waiting on you',
    backToModeration: 'Back to moderation',
    acceptWatched: 'Accept watched ({count})',
    rejectWatched: 'Reject watched ({count})',
    moreOptions: 'More options',
    pageInfo: '{page} / {total} ({count} total)',
    rejectAria: 'Reject',
    acceptAria: 'Accept',
    favoriteAria: 'Favorite',
    aiOverrideTitle: 'The AI rejected {count} videos you had approved',
    aiOverrideBody: 'Explicit content was detected after the video was approved. It has been unpublished and removed from the gallery.',
    aiOverrideAck: 'Acknowledge',
    aiOverrideAckAll: 'Acknowledge all',
  },
  videosPage: {
    ownerFilter: 'Showing videos by {name} · {shown} of {total}',
    ownerFilterClear: 'Show everyone’s videos',
    reanalyze: 'Re-analyze with AI',
    reanalyzeStarted: 'Re-analysis started',
    reanalyzeFailed: 'Could not re-analyze',

    breadcrumb: 'Videos',
    streamProcessing: 'Preparing stream…',
    streamError: 'Streaming failed',
    streamRetry: 'Retry streaming',
    streamRetryQueued: 'Sent to Cloudflare again',
    streamRetryFailed: 'Could not retry',
    titleSuffix: '{name} - Videos',
    countSuffix: '{count} videos',
    selectPageSize: 'Select page size',
    perPage: '{n} per page',
    pageSizeAll: 'All',
    gridView: 'Grid View',
    listView: 'List View',
    exportVideos: 'Export videos',
    deleteAll: 'Delete All',
    deleteAllTitle: 'Delete All Videos',
    deleteAllConfirm: 'Are you sure you want to delete all {count} videos for this event? This will remove both the video files and their records. This action cannot be undone.',
    deleteAllButton: 'Delete All Videos',
    deleted: 'Deleted {count} videos',
    deleteFailed: 'Failed to delete videos',
    noVideos: 'No videos found for this event.',
    play: 'Play',
    pause: 'Pause',
    favorite: 'Favorite',
    unfavorite: 'Unfavorite',
    openViewer: 'Open viewer',
    downloadVideo: 'Download video',
    expand: 'Expand',
    playPause: 'Play/Pause',
    rotate: 'Rotate 90°',
    forceVertical: 'Force vertical',
    unforceVertical: 'Unforce vertical',
    sortLabel: 'Sort videos',
    sortCreatedDesc: 'Newest first',
    sortCreatedAsc: 'Oldest first',
    sortDurationDesc: 'Longest first',
    sortDurationAsc: 'Shortest first',
    sortChallenge: 'By challenge',
    deleteVideo: 'Delete video',
    deleteVideoTitle: 'Delete this video?',
    deleteVideoConfirm: 'The video is removed everywhere: its file, its streaming copy, its AI analysis, the gallery and this list. This cannot be undone.',
    deleteVideoButton: 'Delete video',
    videoDeleted: 'Video deleted',
    videoDeleteFailed: 'Could not delete the video',
    moreInfo: 'More info',
    moreActions: 'More actions',
    sendToStream: 'Send {count} to Cloudflare',
    sendToStreamDone: 'Sent {count} videos to Cloudflare',
    sendToStreamRemaining: '{count} more still to send — press the button again.',
    sendToStreamFailed: 'Could not send the videos to Cloudflare',
    removeStreamCopy: 'Delete Cloudflare copy',
    streamCopyRemoved: 'Cloudflare copy deleted',
    streamCopyRemoveFailed: 'Could not delete the Cloudflare copy',
    streamRemoved: 'Not on Cloudflare (copy deleted)',
    infoTitle: 'Video details',
    infoOwner: 'Sent by',
    infoOwnerName: 'Name',
    infoOwnerEmail: 'Email',
    infoOwnerUid: 'User ID',
    infoOwnerUnknown: 'Unknown',
    infoOwnerFailed: 'Could not look up the sender',
    infoAllByUser: 'All videos by this person',
    infoId: 'Video ID',
  },
  exportDialog: {
    title: 'Export videos',
    summary: '{count} accepted videos will be trimmed, converted to MP4 and zipped.',
    recipients: 'Send to',
    recipientsPlaceholder: 'name@example.com',
    recipientsHelp: 'Press Enter after each address. You always receive a copy.',
    invalidEmail: 'That does not look like an email address.',
    removeRecipient: 'Remove {email}',
    access: 'Link access',
    restricted: 'Restricted — only the people listed here',
    restrictedHelp: 'Recipients sign in to download. People without an account get one and set a password.',
    public: 'Anyone with the link',
    publicHelp: 'No sign-in required. Anyone the link reaches can download the videos.',
    includeReels: 'Include the {count} reels, in their own folder',
    start: 'Start export',
    started: 'Exporting {count} videos',
    reused: 'Nothing has changed — reusing the existing export',
    emailWhenReady: 'You will get an email when the zip is ready.',
    failed: 'Could not start the export',
    reuseNotice: 'An export of these exact videos was built on {date}. It will be shared again instead of re-encoding.',
    runningNotice: 'An export of these videos is already running. Recipients you add will be emailed when it finishes.',
    rebuild: 'Rebuild anyway',
    previewFailed: 'Could not load the export details — the reuse check and the reels option are unavailable. You can still start an export.',
  },
  exportList: {
    title: 'Exports',
    videos: '{count} videos',
    recipients: '{count} recipients',
    progress: '{done} of {total} processed',
    failed: '{count} failed',
    open: 'Open',
    delete: 'Delete this export',
    deleteTitle: 'Delete this export?',
    deleteConfirm: 'The zip and its download links stop working immediately, for all {count} recipients. Videos in the event are not affected. This cannot be undone.',
    deleteButton: 'Delete export',
    deleted: 'Export deleted',
    deleteFailed: 'Could not delete the export',
    mailFailed: 'Ready, but the notification email could not be sent.',
    status: {
      queued: 'Queued',
      processing: 'Processing',
      zipping: 'Zipping',
      ready: 'Ready',
      error: 'Failed',
    },
  },
  displayControls: {
    enable: 'Display controls',
    enabled: 'Display controls on',
    confirmTitle: 'Enable display controls?',
    confirmBody: 'The rotation and force-vertical buttons change how each video appears on the live feed shown on the screens by the desktop playback app. Only use them if you know what they are for.',
    confirmButton: 'Enable',
  },
  reels: {
    breadcrumb: 'Reels',
    streamProcessing: 'Preparing stream…',
    streamError: 'Streaming failed',
    streamRetry: 'Retry streaming',
    sendExisting: 'Send existing reels to Cloudflare',
    sendExistingDone: 'Queued {count} reels',
    titleSuffix: '{name} — Reels',
    countOne: '{count} reel',
    countMany: '{count} reels',
    uploadReel: 'Upload Reel',
    uploading: 'Uploading...',
    uploadingProgress: 'Uploading... {percent}%',
    uploaded: 'Reel uploaded',
    uploadFailed: 'Upload failed',
    deleted: 'Reel deleted',
    deleteFailed: 'Delete failed',
    deleteConfirm: 'Delete "{name}"? This cannot be undone.',
    noReels: 'No reels yet. Upload a video to get started.',
    shareTitle: 'Share Reel',
    shareLink: 'Share link',
    shareNotReady: 'Available once the video finishes processing for streaming',
    shareFailed: 'Failed to create share link',
    favorite: 'Favorite',
    unfavorite: 'Unfavorite',
    favoriteNote: 'Only favourited reels are shown in the event gallery.',
    disable: 'Disable reel',
    enable: 'Enable reel',
    disabledBadge: 'Disabled',
    disableNote: 'Hides the reel from the gallery and its share link. Nothing is deleted.',
    shareDisabled: 'This reel is disabled, so its share link shows that the video is unavailable',
    openViewer: 'Open viewer',
    play: 'Play',
    pause: 'Pause',
    playPause: 'Play/Pause',
    downloadVideo: 'Download video',
    deleteReel: 'Delete reel',
    expand: 'Expand',
    share: 'Share',
    delete: 'Delete',
    edit: 'Edit',
    editReel: 'Edit reel',
    editTitle: 'Edit Reel',
    nameDialogTitle: 'Name this reel',
    thumbnail: 'Thumbnail',
    thumbnailHelp: 'The frame shown before the reel plays, in the gallery and on its share page.',
    thumbnailPending: 'Available once the reel finishes processing for streaming.',
    thumbnailFailed: 'Could not load this frame.',
    reelName: 'Name',
    reelNamePlaceholder: 'Reel name',
    file: 'File',
    replaceFile: 'Replace file',
    chooseFile: 'Choose file…',
    replaceFileHelp: 'Uploads a new video in place. The reel keeps its id, so its share link and QR code stay valid — but the shared page is unavailable until the new stream finishes processing.',
    newFileSelected: 'New file: {name}',
    save: 'Save',
    saved: 'Reel updated',
    saveFailed: 'Failed to update reel',
    replacing: 'Replacing... {percent}%',
  },
  prizes: {
    breadcrumb: 'Prizes',
    title: 'Prize Redemptions',
    redeemed: '{count} redeemed',
    active: '{count} active',
    total: '{count} total',
    none: 'No prizes have been generated yet for this event.',
    columnUid: 'User UID',
    columnStatus: 'Status',
    columnCreated: 'Created',
    columnRedeemed: 'Redeemed At',
    columnRedeemedBy: 'Redeemed By',
  },
  users: {
    title: 'Users',
    subtitle: 'Everyone with an account: staff and participants.',
    filterStaff: 'Staff',
    filterParticipants: 'Participants',
    filterAll: 'All',
    searchPlaceholder: 'Search by name, or an exact email or uid',
    search: 'Search',
    clearSearch: 'Clear',
    loadMore: 'Load more',
    loadFailed: 'Could not load users: {message}',
    empty: 'No accounts here yet.',
    noMatch: 'No account matches “{query}”.',
    anonymous: 'Anonymous',
    badgeSysadmin: 'Sysadmin',
    badgeSeller: 'Seller',
    badgeSalesmanager: 'Sales manager',
    badgeDisabled: 'Sign-in disabled',
    eventCount: '{count} events',
    eventCountOne: '1 event',
    lastSignIn: 'Last sign-in {date}',
    neverSignedIn: 'Never signed in',
    back: 'All users',
    notFound: 'This account no longer exists.',
    you: 'You',
    account: {
      title: 'Account',
      email: 'Email',
      name: 'Name',
      uid: 'UID',
      providers: 'Sign-in methods',
      created: 'Created',
      lastSignIn: 'Last sign-in',
      status: 'Sign-in',
      enabled: 'Allowed',
      disabled: 'Disabled',
      disable: 'Disable sign-in',
      enable: 'Allow sign-in',
      disabledToast: 'Sign-in disabled. They have been signed out.',
      enabledToast: 'Sign-in allowed again.',
      sendReset: 'Send password reset',
      resetSent: 'Password reset sent to {email}',
      selfNote: 'This is your own account.',
    },
    platform: {
      title: 'Platform roles',
      sysadmin: 'Sysadmin',
      sysadminHelp: 'Full access to every event, user and setting.',
      granted: 'Sysadmin granted. It applies on their next sign-in or within an hour.',
      revoked: 'Sysadmin removed. They have been signed out.',
      sales: 'Sales',
      salesNone: 'Not in the sales team.',
      salesRoleSeller: 'Seller',
      salesRoleSalesmanager: 'Sales manager',
      salesActive: 'Active',
      salesInactive: 'Inactive',
      salesActivate: 'Activate',
      salesDeactivate: 'Deactivate',
      salesRoleChanged: 'Sales role changed.',
      salesActiveChanged: 'Sales access updated.',
      enrol: 'Add to sales team',
      enrolName: 'Name',
      enrolKind: 'Kind',
      enrolKindInternal: 'Internal (Google sign-in)',
      enrolKindExternal: 'External (password)',
      enrolRole: 'Role',
      enrolCommission: 'Commission %',
      enrolSubmit: 'Add and send invitation',
      enrolled: 'Added to the sales team and invited.',
      needsEmail: 'An account without an email cannot join the sales team.',
    },
    events: {
      title: 'Events',
      none: 'No role on any event.',
      event: 'Event',
      role: 'Role',
      add: 'Add to event',
      pickEvent: 'Choose an event',
      untitled: '(untitled event)',
      missingEvent: 'Deleted event',
      added: 'Role added.',
      changed: 'Role changed.',
      removed: 'Removed from the event.',
      remove: 'Remove from event',
    },
    roles: {
      eventadmin: 'Event admin',
      moderator: 'Moderator',
      basic: 'Basic',
      weddingadmin: 'Wedding organizer',
    },
    content: {
      title: 'Videos submitted',
      none: 'No videos.',
      summary: '{videos} videos across {events} events',
      counts: '{accepted} accepted · {pending} pending · {rejected} rejected',
    },
    danger: {
      title: 'Remove this person',
      removeAccess: 'Remove access',
      removeAccessHelp: 'Takes away every role and permission. Their login and videos stay.',
      delete: 'Delete account',
      deleteHelp: 'Deletes their login, and optionally every video they submitted.',
    },
    delete: {
      titleAccess: 'Remove all access?',
      titleAccount: 'Delete this account?',
      keepVideos: 'Keep their videos',
      alsoVideos: 'Also delete their {videos} videos',
      willRemove: 'Will be removed',
      willKeep: 'Will be kept',
      irreversible: 'This cannot be undone.',
      typeToConfirm: 'Type {target} to confirm',
      confirmAccess: 'Remove access',
      confirmAccount: 'Delete account',
      confirmEverything: 'Delete account and videos',
      working: 'Removing…',
      tryAgain: 'Try again',
      partial: 'Some things could not be removed. Their login was kept so you can try again:',
      doneAccess: 'Access removed.',
      doneAccount: 'Account deleted.',
      lines: {
        eventRoles: 'Their roles on {count} events',
        sysadmin: 'Sysadmin access',
        salesAccess: 'Access to the sales app',
        profile: 'Their user profile and avatar',
        login: 'Their login',
        videos: '{videos} videos across {events} events, with their streaming copies, files, AI analysis and gallery entries',
        salesRecord: 'Their sales record, marked inactive (closed sales and commissions point at it)',
        eventContent: 'Reels, exports and events they created — those belong to the event',
      },
    },
  },
  shared: {
    notFound: 'Video not found',
    loadFailed: 'Failed to load video',
    streamUnavailable: 'This video is no longer available for streaming',
    unavailable: 'This video is no longer available',
    fullscreen: 'Fullscreen',
    downloadVideo: 'Download video',
    shareVideo: 'Share video',
  },
  language: {
    label: 'Language',
  },
  eventTypes: {
    changeTitle: 'Change event type',
    changeType: 'Type',
    changeUrl: 'Webapp URL',
    changeFields: 'Applying the new type’s defaults would change these fields:',
    changeNoFields: 'No preset fields differ; only the type and URL change.',
    changePreserveNote: 'Name, challenges, images and other content you set are preserved either way.',
    changeTypeOnly: 'Change event type only',
    changeTypeOnlyTip: 'Changes the type and the webapp URL, and nothing else. Every setting keeps its current value, even where the new type’s default differs.',
    changeApplyDefaults: 'Change and apply defaults',
    changeApplyDefaultsTip: 'Changes the type and the webapp URL, and resets these settings to the new type’s defaults:',
    changeApplyDefaultsNone: 'The new type’s defaults already match this event, so there is nothing to apply.',
    changed: 'Event type changed',
    changeFailed: 'Failed to change event type',
    title: 'Event Types',
    subtitle: 'Configure presets and behavior per event type',
    slug: 'slug',
    entryFlow: 'entry',
    labelEn: 'Label (EN)',
    labelEs: 'Label (ES)',
    tagColor: 'Tag color',
    adminRole: 'Admin role',
    capModeration: 'Moderation',
    capPrizes: 'Prizes',
    hiddenSections: 'Hidden config sections',
    defaults: 'Default values',
    saved: 'Event type saved',
    saveFailed: 'Failed to save event type',
    seed: 'Seed defaults',
    seeded: 'Seeded {{count}} type(s)',
    seedFailed: 'Failed to seed types',
  },
  templates: {
    title: 'Email Templates',
    subtitle: 'Default copy for every email the platform sends. Events start from these.',
    eventTitle: 'Email templates',
    eventSubtitle: 'Copy sent to this event’s participants and admins. Prefilled from the defaults.',
    language: 'Email language',
    languageHelp: 'Which language this event’s emails are sent in.',
    subject: 'Subject',
    body: 'HTML body',
    text: 'Text',
    placeholders: 'Placeholders — click to insert',
    unknownPlaceholders: 'Unknown placeholder(s): {names}. These are not filled in and will be sent as written.',
    showPreview: 'Preview',
    hidePreview: 'Hide preview',
    restoreDefault: 'Restore default',
    saved: 'Template saved',
    saveFailed: 'Could not save the template',
    testTo: 'Send a test to',
    testSend: 'Send test',
    testSending: 'Sending…',
    testHelp: 'Sent with sample values and a [TEST] subject prefix. Sends what is on screen, saved or not.',
    testSent: 'Test email sent to {email}',
    testFailed: 'Could not send the test email',
    name: {
      invite: 'Admin invitation',
      roleAdded: 'Added to an event',
      prize: 'Prize won',
      contact: 'Contact form',
      videoExportReady: 'Video export ready',
      videoExportInvite: 'Video export ready (new account)',
      videoExportFailed: 'Video export failed',
      sellerInvite: 'Seller invitation (password)',
      sellerInviteGoogle: 'Seller invitation (Google sign-in)',
      salesReminder: 'Daily sales reminder',
      passwordReset: 'Password reset',
      reelShare: 'Reel share text',
    },
    description: {
      invite: 'Sent when an admin is invited and must set a password.',
      roleAdded: 'Sent when someone with an existing account is added to an event.',
      prize: 'Sent to a participant who has completed every challenge.',
      contact: 'Sent to hola@crowds.cl from the landing page contact form.',
      videoExportReady: 'Sent when a bulk video export finishes, to everyone it was shared with.',
      videoExportInvite: 'Sent instead when the recipient has no password yet and the export is restricted.',
      videoExportFailed: 'Sent to whoever started an export when it fails, so nobody is left waiting for a link that is not coming. Recipients are not told.',
      sellerInvite: 'Sent to an external seller, with a link to set a password.',
      sellerInviteGoogle: 'Sent to an internal seller, who signs in with Google.',
      salesReminder: 'One mail per seller each morning with the leads due today or overdue.',
      passwordReset: 'Sent when someone uses "Forgot password" on the admin, the webapp or the sales app.',
      reelShare: 'Not an email: the text a guest’s phone attaches when they share one of the event’s reels (copied to the clipboard for Instagram). The link to the reel is added after it automatically.',
    },
  },
  exportPage: {
    count: '{count} videos',
    failed: '{count} could not be processed',
    partSize: '{count} videos · {size} MB',
    download: 'Download',
    expires: 'This link works until {date}.',
    unavailable: 'This export is not available',
    error: {
      denied: 'This export has not been shared with the account you are signed in with.',
      notReady: 'This export is still being prepared. Try again in a few minutes.',
      gone: 'The link has expired or the export no longer exists. Ask whoever shared it for a new one.',
      deleted: 'An administrator of the event deleted this export, so the videos are no longer available here. Ask whoever shared it with you if you still need them \u2014 they can prepare it again.',
      temporary: 'Something went wrong preparing this download. Please try again in a few minutes — if it keeps happening, contact whoever shared it with you.',
    },
  },
  analytics: {
    title: 'Analytics',
    navLink: 'Analytics',
    breadcrumb: 'Analytics',
    lastUpdated: 'Last updated: {date}',
    notYetComputed: 'Not yet computed',
    recompute: 'Recompute',
    recomputing: 'Recomputing...',
    recomputeSuccess: 'Analytics recomputed. {remaining} computations remaining today.',
    recomputeUnlimited: 'Analytics recomputed.',
    recomputeLimitReached: 'Daily computation limit reached. Try again tomorrow.',
    recomputeError: 'Failed to recompute analytics.',
    emptyState: 'No analytics yet — click Recompute to generate them.',
    tier: 'Analytics tier',
    tierFree: 'Free',
    tierPro: 'Pro',
    metricUsableRate: 'Usable content rate',
    metricSubmissions: 'Submissions',
    metricAccepted: 'Accepted',
    metricRejected: 'Rejected',
    metricParticipants: 'Unique participants',
    metricSubmissionsPerParticipant: 'Submissions / participant',
    metricRedemptionRate: 'Redemption rate',
    metricAvgDuration: 'Avg. clip duration',
    secondsUnit: '{value}s',
    peakTimesTitle: 'Peak submission times',
    hourLabel: '{hour}:00',
    timezoneLabel: 'Time zone',
    challengeBreakdownTitle: 'Challenge breakdown',
    colChallenge: 'Challenge',
    colSubmissions: 'Submissions',
    colAccepted: 'Accepted',
    colRejected: 'Rejected',
    colAcceptRate: 'Accept rate',
    costCalculatorTitle: 'Cost calculator',
    costInput: 'Total event cost',
    costStorageNote: 'This value is kept only in your browser.',
    costPerScan: 'Cost per scan',
    costPerParticipant: 'Cost per participant',
    costPerSubmission: 'Cost per submission',
    costPerUsableClip: 'Cost per usable clip',
    costPerRedemption: 'Cost per redemption',
  },
  videoAI: {
    backfillStarted: 'Analyzing {count} videos in the background. You can leave this page.',

    title: 'AI video analysis',
    enable: 'Enable AI video analysis',
    featuresLabel: 'Detections to run',
    featureExplicit: 'Explicit content detection',
    featureFace: 'Face detection',
    featureLabel: 'Label detection',
    featureLogo: 'Logo recognition',
    featureObject: 'Object tracking',
    featurePerson: 'Person detection',
    featureSpeech: 'Speech transcription',
    featureText: 'Text detection',
    aiModeration: 'AI moderation (reject explicit videos automatically)',
    thresholdLabel: 'Reject when explicit content is at least',
    thresholdPOSSIBLE: 'Possible',
    thresholdLIKELY: 'Likely',
    thresholdVERY_LIKELY: 'Very likely',
    costLine: 'Estimated cost: {perSecond} per second of video ({perMinute}/min).',
    costFree: 'The first {minutes} minutes each month are free.',
    costNone: 'No detections selected — nothing will be analyzed or billed.',
    saved: 'AI settings saved',
    saveFailed: 'Could not save AI settings',
    backfill: 'Analyze existing videos',
    backfillUnsavedChanges: 'Save your changes first — the backfill runs the saved settings, not what is on screen.',
    backfillTitle: 'Analyze existing videos',
    backfillCounting: 'Counting videos…',
    backfillNothing: 'Every video in this event is already up to date with the saved settings.',
    backfillSummary: '{count} videos are missing detections the saved settings ask for ({duration} of video).',
    backfillAdds: 'Only the missing detections run: {features}.',
    backfillCost: 'Estimated cost: {cost}.',
    backfillBackground: 'It runs in the background — you can leave this page and follow it here or on the Videos page.',
    backfillModeration: 'Also apply AI moderation to the results',
    backfillModerationHint: 'Off by default. Turning this on can reject videos a moderator already approved.',
    backfillRun: 'Analyze {count} now',
    backfillFailed: 'Backfill failed',
    jobStatus: {
      running: 'Running',
      done: 'Finished',
      stopped: 'Stopped',
      error: 'Failed',
    },
    jobAdds: 'Adds {features}',
    jobModerationOn: 'AI moderation on',
    jobModerationOff: 'AI moderation off',
    jobProgress: '{done} of {total} videos',
    jobFailed: '{count} failed',
    jobStartedBy: 'Started by {name}, {date}',
    jobFinishedAt: 'ended {date}',
    jobRetryHint: 'Press "Analyze existing videos" again to retry the failed ones.',
    jobStoppedHint: 'Stopped before the end. The next run picks up the rest.',
    jobStop: 'Stop',
    jobStopped: 'Analysis stopped',
    jobStopFailed: 'Could not stop the analysis',
    jobStripTitle: 'AI analysis',
    jobView: 'View',
  },
  guests: {
    generate: 'Generate guest list',
    regenerate: 'Update list',
    generating: 'Generating list…',
    count: 'Guests who shared videos: {count}',
    copy: 'Copy names',
    copied: 'Names copied',
    empty: 'No accepted videos with a name yet.',
    unnamed: 'Videos without a name, not listed: {count}',
  },
  workspace: {
    navLabel: 'Event',
    sectionPicker: 'Go to',
    allEvents: 'All events',
    notFound: 'This event does not exist, or you do not have access to it.',
    groupRun: 'Run the event',
    groupLook: 'Look',
    groupExperience: 'Participant experience',
    groupVideos: 'Videos',
    groupTeam: 'Team',
    groupEvent: 'Event',
    overview: 'Overview',
    overviewIntro: 'How this event is set up, and where to change it.',
    openModeration: 'Open moderation',
    glanceTitle: 'At a glance',
    badgeReceptionClosed: 'Reception closed',
    badgeAutoApprove: 'Auto-approve',
    badgeAiModeration: 'AI moderation',
    badgeChallengesOne: '{count} challenge',
    badgeChallengesMany: '{count} challenges',
    badgePrize: 'Prize mode',
    badgeRecording: '{clip}s clips · {max}s max',
    badgeStreaming: 'Streaming',
    badgeStreamingPublic: 'Streaming · public gallery',
    classicLink: 'Classic page',
    classicNotice: 'This is the classic event page, kept in case it is needed. The new event workspace is the default.',
    classicBack: 'Back to the new page',
    tabRecording: 'Recording',
    tabReception: 'Reception',
    tabModeration: 'Moderation rules',
    tabAI: 'Video AI',
    tabAdmins: 'Admins',
    tabInfo: 'Info & terms',
    tabGeneral: 'General',
    tabShare: 'Share & QR',
    tabPlan: 'Analytics plan',
    tabGuests: 'Guests',
    descImages: 'What participants see behind each screen of the webapp.',
    descTheme: 'The webapp\'s colours for this event.',
    descChallenges: 'The prompts participants pick from before they record.',
    descPrize: 'Complete every challenge, win a prize, redeem it at the stand.',
    descRecording: 'How long participants can record, and how long a clip they can send.',
    descReception: 'When this event takes new videos.',
    descModeration: 'How new videos reach the moderation queue.',
    descAI: 'Automatic analysis of new videos, and rejection of explicit content.',
    descStreaming: 'Cloudflare playback and the public gallery.',
    descAdmins: 'Who can run and moderate this event. Changes apply immediately.',
    descGeneral: 'The event\'s name and type.',
    descShare: 'The link and QR code participants join with.',
    descPlan: 'How this event\'s numbers are kept up to date.',
    descGuests: 'Everyone who shared an accepted video, by the name they gave on entry.',
    changeTypeHelp: 'Changing the type changes which settings the event has. You will be asked to confirm.',
    deleteHelp: 'Deletes the event and everything that belongs to it. This cannot be undone.',
    unsavedMark: 'Unsaved changes',
    unsavedElsewhere: '{tab} has unsaved changes.',
    backToTab: 'Back to it',
    leaveTitle: 'Unsaved changes in {tab}',
    leaveBody: 'Save them before leaving, or discard them?',
    stay: 'Stay',
    discard: 'Discard',
    saveAndLeave: 'Save and continue',
  },
}

export default en
